import {
  Box,
  BoxProps,
  Flex,
  ListItem,
  ListItemProps,
  Text,
} from "@chakra-ui/react";
import * as React from "react";

export const FlushedDetail = (
  props: ListItemProps & {
    label: string;
    icon?: React.ReactNode;
  },
) => {
  const { label, icon, ...rest } = props;

  return (
    <ListItem
      display="flex"
      alignItems="flex-start"
      fontWeight="medium"
      maxW="260px"
      {...rest}
    >
      <Flex direction="column" align="center" gap="4">
        {icon && <Box as={icon as BoxProps["as"]} w="3xs" />}
        <Text as="span" display="inline-block" fontSize="md">
          {label}
        </Text>
      </Flex>
    </ListItem>
  );
};
